import React from 'react';

import {NavLink} from 'react-router-dom';
import Router from 'router/router';
import * as css from './css/service';
import {observer} from 'mobx-react';
import useMyStores from "hooks/useMyStores";

function Service(props) {
    const {className} = props;

    const {service, user, login} = useMyStores()

    return (
        <css.Service className={className}>
            <css.Container>
                <div className='title'>
                    <span className='title-text'>客户服务</span>
                    <img
                        src={require('./img/arrow-up.png')}
                        alt=''
                        className='arrow-up'
                    />
                </div>
                <css.LinkBLockWrapper>
                    <css.LinkBlock>
                        <css.Link
                            onClick={() => {
                                if (!user.token) {
                                    login.show = true;
                                } else {
                                    service.show = true;
                                }
                            }}
                        >
                            在线咨询
                        </css.Link>
                        <css.Link as={NavLink} to={Router.Help.path}>
                            帮助中心
                        </css.Link>
                    </css.LinkBlock>
                </css.LinkBLockWrapper>
            </css.Container>
        </css.Service>
    );
}

export default observer(Service);
